import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd0a9942"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-header" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "from" }, "从值", -1))
const _hoisted_4 = { class: "old-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "to" }, "改为", -1))
const _hoisted_6 = { class: "new-value" }
const _hoisted_7 = {
  key: 1,
  class: "empty-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_ctx.modelValue && _ctx.modelValue.length > 0)
    ? (_openBlock(), _createBlock(_component_el_timeline, {
        key: 0,
        style: {"width":"calc(100% - 40px)"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, i) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              key: i,
              timestamp: _ctx.handleDateFormat(item.CreatedTime),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(item.Label), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Items, (log, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "log",
                    key: i
                  }, [
                    _createElementVNode("span", _hoisted_2, [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: log.Label,
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("pre", null, _toDisplayString(log.Label ? log.Label : "暂无数据"), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _hoisted_3,
                    _createElementVNode("span", _hoisted_4, [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: log.OldValue,
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("pre", null, _toDisplayString(log.OldValue ? log.OldValue : "暂无数据"), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        content: log.NewValue,
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("pre", null, _toDisplayString(log.NewValue ? log.NewValue : "暂无数据"), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["timestamp"]))
          }), 128))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无数据"))
}